import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_balance_sheet,
    getReportLabel: () => t`Balance Sheet`,
    getColumns: () => [],
};
